module.exports = __webpack_public_path__ + "img/finagent-chat-icon-light.229ee61.svg";